<template>
  <div>
    <div class="pr-4 pb-4">
      <v-text-field
        light
        label="Title"
        v-model="item.name"
        type="text"
        required
        color="amber"
        placeholder="Name"
      ></v-text-field>
      <v-text-field
        light
        label="Sentence"
        v-model="item.sentence"
        type="text"
        required
        color="amber"
        placeholder="In a sentence"
      ></v-text-field>
      <v-select
        light
        :items="colors"
        label="Colour code"
        :value="item.color"
        v-model.trim="item.color"
        item-text="title"
        item-value="color"
        class="mr-4 mt-8"
      ></v-select>
      <v-expansion-panels v-model="panel" light class="">
        <v-expansion-panel>
          <v-expansion-panel-header
            >Historical narrative</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-textarea
              light
              label="Historical Narrative"
              v-model="item.historical"
              type="text"
              color="amber"
              :rows="2"
              :autoGrow="true"
              :hide-details="true"
              placeholder="Historical Narrative"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Tags</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-select
              :items="local.categories"
              label="Categories"
              multiple
              v-model.trim="item.categories"
              light
            ></v-select>

            <v-select
              :items="local.assets"
              label="Assets"
              multiple
              v-model.trim="item.assets"
              light
            ></v-select>

            <v-select
              :items="local.tags"
              label="Tags"
              multiple
              v-model.trim="item.tags"
              light
            ></v-select>

            <v-select
              :items="local.audiences"
              label="Audiences"
              multiple
              v-model.trim="item.audiences"
              light
            ></v-select>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Stats</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-slider
              v-model="item.scores.education"
              label="Education"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
            <v-slider
              v-model="item.scores.culture"
              label="Culture"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
            <v-slider
              v-model="item.scores.leisure"
              label="Leisure"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
            <v-slider
              v-model="item.scores.residential"
              label="Residential"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
            <v-slider
              v-model="item.scores.commercial"
              label="Commercial"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
            <v-slider
              v-model="item.scores.hospitality"
              label="Hospitality"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
            <v-slider
              v-model="item.scores.retail"
              label="Retail"
              step="1"
              min="0"
              max="5"
              ticks="always"
              tick-size="1"
              color="amber text--black"
              track-color="grey lighten-2"
              light
            ></v-slider>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Narrative</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-textarea
              light
              label="Narrative"
              color="amber"
              v-model.trim="item.body"
              :rows="2"
              :autoGrow="true"
              :hide-details="true"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Features</v-expansion-panel-header>
          <v-expansion-panel-content>
            <unit-sub-items v-model="item.features" name="sub">
              <v-label
                ><span class="black--text"
                  >Define the features of the offer</span
                ></v-label
              >
              <p class="ma-0">Type below and press <strong>Add</strong></p>
            </unit-sub-items>
            <unit-sub-items v-model="item.benefits" name="sub">
              <v-label
                ><span class="black--text"
                  >Define the benefits of the offer</span
                ></v-label
              >
              <p class="ma-0">Type below and press <strong>Add</strong></p>
            </unit-sub-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <div class="d-flex justify-end align-center pr-3">
      <v-btn @click="submit" small color="amber" class="mr-2" light
        >Change</v-btn
      >
      <v-btn @click="cancel" small color="grey" class="" light>Cancel</v-btn>
    </div>
  </div>
</template>

<script>
import { itemModel } from './model'
import { UnitSubItems } from '@/components/units'

export default {
  name: 'OfferSystemForm',
  components: { UnitSubItems },
  props: {
    newItem: {
      type: Object,
      default: () => {}
    },
    colors: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    local: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      item: this.createItem(this.newItem),
      panel: [0, 1]
    }
  },
  methods: {
    createItem(item) {
      const proto = {}
      Object.keys(itemModel).forEach(key => {
        proto[key] = item[key] ? item[key] : itemModel[key]
      })
      return proto
    },
    submit() {
      this.$emit('submit', this.item)
    },
    cancel() {
      this.$emit('cancel', this.item)
    }
  }
}
</script>
